import { createFileRoute, Navigate } from '@tanstack/react-router';

import { CrmCustomerSyncPage } from '@pages/crm';
import { useCrmCustomerRecordRouteGuard } from '@widgets/crm-customer-record-shell';

export const Route = createFileRoute(
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/sync'
)({
  component: CrmCustomerSyncRoute,
});

function CrmCustomerSyncRoute() {
  const { userProfileId: customerId, locale } = Route.useParams();
  const search = Route.useSearch();
  const fallback = useCrmCustomerRecordRouteGuard('sync');
  if (fallback !== null) {
    return (
      <Navigate
        to={fallback.route}
        params={{ userProfileId: customerId, locale }}
        replace
        resetScroll={false}
        search={search}
      />
    );
  }
  return <CrmCustomerSyncPage />;
}
